module.exports = __webpack_public_path__ + "media/store/images/arrowVector-995dd7484b9f8383f14c5d52301ed5ff.svg";